import styled from "../../../../../config/emotion";
import { StyledCompProps } from "../../../../../globalTypes/theme";

export const ListContainer = styled.div`
  position: relative;
  max-height: calc(100vh - 550px);
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  margin-top: 5px;
`;

export const ListItemContainer = styled.div<StyledCompProps>`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 0.5em 1em;

  span {
    color: ${({ theme }) => theme.colors.secondaryColor};
    font-weight: bold;
    margin-left: 0.5em;
    font-size: 14px;
  }

  div {
    margin: 5px;
  }
`;
